import { AlertTriangle } from "lucide-react";
import { useProducts } from "@/hooks/useProducts";
import { T } from "@/lib/i18n";

const REPOUSS = /extr[eê]me[ -]?repouss|extreme-repouss/i;

/** Vrai si le produit est un Extrême Repouss ou un pack qui en contient. */
export const hasRepouss = (p) =>
  REPOUSS.test([p?.slug, p?.name, ...(p?.contents || []), ...(p?.components || []).map((c) => c?.slug)].join(" "));

/** Vrai si un texte (article, guide) mentionne l'Extrême Repouss. */
export const mentionsRepouss = (text) => REPOUSS.test(typeof text === "string" ? text : JSON.stringify(text ?? ""));

/** Vrai si un article du panier (produit, pack ou pack composé) contient l'Extrême Repouss. */
export function useCartHasRepouss(items) {
  const { data } = useProducts();
  const all = Array.isArray(data) ? data : [];
  return (items || []).some((i) => hasRepouss(all.find((p) => p.slug === i.slug) || i) || (i.box || []).some(hasRepouss));
}

export function PregnancyNotice({ testid = "pregnancy-notice", className = "mt-8" }) {
  return (
    <p data-testid={testid} role="note" className={`${className} flex max-w-3xl gap-3 rounded-sm border border-[#e8a87c]/60 bg-[rgba(232,168,124,0.1)] p-4 text-sm leading-relaxed text-[var(--parchment)]`}>
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-[#e8a87c]" aria-hidden="true" />
      <span><strong className="font-semibold"><T>Grossesse et allaitement :</T></strong><T> les soins Extrême Repouss ne doivent pas être utilisés pendant la grossesse. Attendez la fin de l'allaitement avant de les utiliser.</T></span>
    </p>
  );
}
